/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ItemContractTypes = 'Purchase' | 'Rent' | 'Lease' | 'LeasePurchase' | 'ContractForWork';

export const ItemContractTypes = {
    Purchase: 'Purchase' as ItemContractTypes,
    Rent: 'Rent' as ItemContractTypes,
    Lease: 'Lease' as ItemContractTypes,
    LeasePurchase: 'LeasePurchase' as ItemContractTypes,
    ContractForWork: 'ContractForWork' as ItemContractTypes
};

